import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import { NavLink } from "react-router-dom";

import './style.css'
// import { Link } from "react-scroll";


const pages = [
  {
    name: "Home", link: "/"
  }, {
    name: "Download", link: "/download"
  }, {
    name: "Notifications", link: "/notifications"
  },
  {
    name: "Public Hearing", link: "/public_hearing"
  },
  {
    name: "Photo Gallery", link: "/photo-gallery"
  },
  {
    name: "Annual Report", link: "/annual-report"
  },
  {
    name: "News Letter", link: "/news-letter"
  },
  {
    name: "Frequently Asked Questions", link: "/faq"
  },
  {
    name: "Contact Us", link: "/contact_us"
  },
  {
    name: "Site Map", link: "/sitemap"
  }
];

function TopNav() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  function navigation() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#0b4285", overflow: "hidden", marginTop: "-10px" }}>
      <Container maxWidth="xxl" style={{ width: "100%", }}>
        <Toolbar disableGutters>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, alignItems: "center" }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "flex", md: "none", width:"100vh" },
              }}
              MenuListProps={{ disablePadding: true }}
            >
              {pages.map((page, index) => (
                <MenuItem key={page.name} onClick={handleCloseNavMenu} sx={{
                  backgroundColor: "#0b4285",
                  "&:hover": {
                    backgroundColor: "rgba(6, 0, 129, 1)",
                  },
                }}


                >
                  <NavLink
                    onClick={navigation}
                    style={{ textDecoration: "none", color: "white", }}
                    to={page.link}
                  >

                    <Typography variant="h6" style={{ cursor: 'pointer' }} >{page.name}</Typography>
                  </NavLink>

                </MenuItem>
              ))}
            </Menu>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                display: { xs: "flex-start", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".1rem",
                color: "white",
                textDecoration: "none",
              }}
            >
              MENU
            </Typography>
          </Box>

          <Box sx={{
            flexGrow: 1, display: { xs: "none", md: "flex" },
            justifyContent: "center"
          }}>
            {pages.map((page, index) => (
              <MenuItem key={page.name} onClick={handleCloseNavMenu} className="top_nav" >
                <NavLink
                  onClick={navigation}
                  className={`${(navData) => (navData.isActive ? 'active' : '')} `}
                  style={{ textDecoration: "none", color: "white" }}
                  to={page.link}
                >

                  <Typography variant="h6" style={{ cursor: 'pointer', fontSize: "1rem", margin: "0 10px" }} >{page.name}</Typography>
                </NavLink>

              </MenuItem>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default TopNav;
